<div class="flex flex-row gap-2 items-center">
  <div class="flex flex-col leading-[1.2] max-w-[100px]">
    @if (countryName()) {
      <span class="country truncate">{{ countryName() }}</span>
    }
    @if (stateName()) {
      <span class="text-gray-500 text-xs! truncate">{{ stateName() }}</span>
    }
  </div>

  <img
    class="w-6 h-[16px]"
    [class.hidden]="!countryIso2()"
    [src]="
      countryIso2()
        ? 'https://flagcdn.com/w80/' +
          countryIso2().toLowerCase() +
          '.png'
        : null
    "
    alt=""
    (error)="onFlagError($event)"
  />
</div>